import Vue from 'vue'
import Router from 'vue-router'



// Main componentes
import Explore from './dashboard/Explore.vue'
import Dashboard from './dashboard/DashboardNew.vue'
import Onboarding from './dashboard/Onboarding.vue'
import Project from './dashboard/Project/Index.vue'
import Account from './dashboard/Account/Index.vue'
import CreateProject from './dashboard/Create.vue'

// Legacy
import Model from './dashboard/Model/Index.vue'
import Dataset from './dashboard/Dataset/Index.vue'

// Header menu
import Home from './dashboard/Home.vue'
import Spaces from './dashboard/Spaces.vue'
// Header menu for admin
import HomeAdmin from './dashboard/HomeAdmin.vue'
// import Login from './dashboard/Login.vue'
import SignUp from './dashboard/SignUp.vue'

// ADMIN
import AdminUsers from './dashboard/admin/Users.vue'
import AdminProjects from './dashboard/admin/Projects.vue'

import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/analytics'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { 
      path: '/explore/:searchString?',
      component: Home,
      props: {
        username: true,
      },
      path: '/spaces/:projectId',
      component: Spaces,
      props: true,
      meta: {
        requiresAuth: false,
        title: 'Metatext - Pre-Build Models and APIs'
      },
      children: [
        {
          path: '',
          component: Explore,
          props: true
        },
      ]
    },
    {
        path: '/create',
        name: 'Create',
        component: CreateProject,
        props: true,
        meta: {
            requiresAuth: true
        }
      },
    {
      path: '/',
      component: Home,
      props: {
        username: true,
      },
      meta: {
        requiresAuth: true,
        title: 'Metatext AI - Create Powerful NLP Models'
      },
      children: [
        {
          path: '/onboarding',
          name: 'Onboarding',
          component: Onboarding,
          props: true,
        },
        {
          path: '',
          redirect: "dashboard"
        },
        {
          path: '/app',
          redirect: "dashboard"
        },
        {
          path: 'explore',
          component: Explore
        },
        {
          path: 'dashboard/:start?/:stepId?',
          name: 'Dashboard',
          component: Dashboard,
          props: true
        },
        {
            path: 'd/:start?/:stepId?',
            name: 'D',
            component: Dashboard,
            props: true
        },
        {
          path: 'projects/:projectId/:stepId?/:tabId?',
          name: 'Project',
          component: Project,
          props: true
        },
        {
          path: 'models/:modelId/:stepId?',
          name: 'Model',
          component: Model,
          props: true
        },
        {
          path: 'datasets/:datasetId/:stepId?/:filterId?',
          name: 'Dataset',
          component: Dataset,
          props: true
        },
        {
          path: 'account/:stepId?',
          name: 'Account',
          component: Account,
          props: true
        },
        {
            path: 'checkout/:stepId/:paymentType?/:action?/:sessionState?',
            component: Account,
            props: true
          },
      ]
    },
    {
      path: '/admin',
      component: HomeAdmin,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        title: 'App Admin'
      },
      children: [
        {
          path: '',
          component: AdminUsers
        },
        {
          path: 'users',
          component: AdminUsers
        },
        {
            path: 'projects',
            component: AdminProjects
        },
      ]
    },
    {
      path: '/login',
      component: SignUp,
      meta: {
        authPage: true
      }
    },
    {
      path: '/signup',
      component: SignUp,
      meta: {
        authPage: true
      }
    },
    // Open Public models / APIs
    
    
  ]
})

// This callback runs before every route change, including on page load.

router.beforeEach((to, from, next) => {
  if (firebase.auth().currentUser && to.fullPath == "/") {
    next("/")
  }
  else if (to.matched.some(it => it.meta.requiresAdmin)) {

    if (firebase.auth().currentUser.email === "rafaelsandronidias@gmail.com") {
      next()
    }
    else {
      next("/")
    }
  }
  else if (to.matched.some(it => it.meta.requiresAuth)) {
    if (firebase.auth().currentUser) {

      next()
    }
    else {
      next("/login")
    }
  }
  else if (to.matched.some(it => it.meta.authPage) && firebase.auth().currentUser) {
    next("/")
  }
  else {
    next()
  }

  const suffix_title = ""

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  document.title = document.title + suffix_title

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
})

export default router